module.exports = __webpack_public_path__ + "static/media/31-5.e3309356.mp3";